const state = () => ({
  step: 0
});

// getters
const getters = {
  currentStep: state => state.step
};

// actions
const actions = {
  // goToNextStep({ commit, state, getters }) {
  //   commit("setStep", getters.step + 1);
  // }
};

// mutations
const mutations = {
  goToNextStep(state) {
    state.step += 1;
  },
  goToPreviousStep(state) {
    state.step += 1;
  },
  setStep(state, step) {
    state.step = step;
  },
  setIsShowCase(state) {
    state.isShowCase = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
